import { StyleSheet } from 'react-native';
import {
  bold,
  editLinkColor,
  defaultWidth,
  fontSizeMedium,
} from '../../constants/palette';

const styles = StyleSheet.create({
  contentContainer: {
    // flex: 1,
    justifyContent: 'center',
    paddingTop: 20,
    alignItems: 'center',
  },

  container: {
    // flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  createButtonContainer: {
    marginTop: 25,
  },
  editLinkText: {
    color: editLinkColor,
    fontWeight: bold,
    fontSize: fontSizeMedium,
  },
  fanGenreErrorText: {
    fontSize: fontSizeMedium,
    width: defaultWidth,
    textAlign: 'center',
  },
  platformText: {
    marginBottom: 20,
    fontSize: fontSizeMedium,
    width: 275,
  },
});

export default styles;
